// extracted by mini-css-extract-plugin
export var actionButton = "_xq-2";
export var card = "_xq-0";
export var errorCard = "_xq-1";